import CapitalGainAmountError from './CapitalGainAmountError';
class InvalidCapitalGainAmount extends CapitalGainAmountError {
    constructor(options) {
        super('INVALID_CAPITAL_GAIN_AMOUNT', options);
    }
}
export default InvalidCapitalGainAmount;
